import { postProcessPrimeData, isLocalEnv } from './prime-core.js';

/**
 * .prime-matches-section: season/tournament/team selectors and the
 * generate-matches-image button.
 * Used by the page-template-matches-image page template.
 */

function match_schedule_promo_get_tournaments($select) {
  let oTheContainer;
  const oTheSelected = $select.find('option:selected');

  oTheContainer = oTheSelected.attr('data-selector-container');
  $(oTheContainer).empty().append('<option>&nbsp;...&nbsp;</option>');

  if ($('.prime-tournaments').length > 0) {
    $('.prime-tournaments').empty().append('<option value="0">Velg turnering</option>').prop('selected', 'selected').prop('disabled', 'disabled');
  }
  if ($('.prime-teams').length > 0) {
    $('.prime-teams').empty().append('<option value="0">Velg lag</option>').prop('selected', 'selected').prop('disabled', 'disabled');
  }

  $('.prime-matches-section')
    .attr('data-season', oTheSelected.val())
    .attr('data-tournament-id', '')
    .attr('data-team-id', '');

  window.Ajax.prime_v2(
    {
      template   : oTheSelected.attr('data-selector-template'),
      id         : oTheSelected.val(),
      queryString: oTheSelected.attr('data-selector-query'),
      queryType  : oTheSelected.attr('data-query-type'),
      container  : oTheSelected.attr('data-selector-container'),
    },
    function(data) {
      $(oTheContainer).empty().append(data.markup).prop('disabled', false).removeProp('disabled');
      if (window.getUrlParameter('tournament_id')) {
        $(oTheSelected.attr('data-selector-container')).val(window.getUrlParameter('tournament_id')).trigger('change');
      }
    },
    function(data) { window.showError(data); }
  );
}

function initMatchesImageSelectors() {
  // Season auto-trigger for image template pages
  if ($('body').hasClass('page-template-template-matches-image') && $('body').hasClass('team')) {
    if (window.getUrlParameter('nth_season')) {
      match_schedule_promo_get_tournaments($('.prime-seasons'));
    }
  } else if ($('body').hasClass('page-template-template-matches-image') && $('body').hasClass('nth')) {
    $('.prime-seasons').val('2526').trigger('change');
    match_schedule_promo_get_tournaments($('.prime-seasons'));
  }

  $(document).on('change', '.prime-matches-section .prime-filter-item select.prime-seasons', function() {
    match_schedule_promo_get_tournaments($(this));
  });

  // Tournaments
  $(document).on('change', '.prime-matches-section .prime-filter-item select.prime-tournaments', function() {
    const oTheSelected = $(this).find('option:selected');
    let oTheContainer  = oTheSelected.attr('data-selector-container');
    $(oTheContainer).empty().append('<option>&nbsp;...&nbsp;</option>');

    if ($('.prime-teams').length > 0) {
      $('.prime-teams').empty().append('<option value="0">' + $('.prime-teams').attr('data-label') + '</option>').prop('disabled', 'disabled');
    }

    $('.prime-matches-section').attr('data-tournament-id', oTheSelected.val()).attr('data-team-id', '');

    window.Ajax.prime_v2(
      {
        template   : oTheSelected.attr('data-selector-template'),
        id         : oTheSelected.val(),
        queryString: oTheSelected.attr('data-selector-query'),
        queryType  : oTheSelected.attr('data-query-type'),
        container  : oTheSelected.attr('data-selector-container'),
      },
      function(data) {
        $(oTheContainer).empty().append(data.markup).prop('disabled', false).removeProp('disabled');
        if (window.getUrlParameter('team_id')) {
          $(oTheSelected.attr('data-selector-container')).val(window.getUrlParameter('team_id')).trigger('change');
        }
      },
      function(data) { window.showError(data); }
    );
  });

  // Teams
  $(document).on('change', '.prime-matches-section .prime-filter-item select.prime-teams', function() {
    $('.prime-matches-section').attr('data-team-id', $(this).find('option:selected').val());
  });

  // Format checkboxes
  $(document).on('change', '.prime-matches-section .prime-filter-item .format:not(.include-all)', function() {
    $('.prime-matches-section').attr('data-format', $(this).val());
  });

  $(document).on('change', '.prime-matches-section .prime-filter-item .format.include-all.include-all-tournaments', function() {
    $('.prime-matches-section').attr('data-include-all-tournaments', $(this).prop('checked') ? true : 0);
    $('.form-control.prime-tournaments').prop('disabled', $(this).prop('checked'));
  });

  $(document).on('change', '.prime-matches-section .prime-filter-item .format.include-all.include-all-teams', function() {
    const checked = $(this).prop('checked');
    $('.prime-matches-section').attr('data-include-all-teams', checked ? true : 0);

    if (checked) {
      $('.form-control.prime-teams, .form-control.prime-tournaments').prop('disabled', true);
      $('.prime-matches-section .prime-filter-item .format.include-all.include-all-tournaments')
        .prop('disabled', true).next().addClass('-is-disabled');
    } else {
      $('.form-control.prime-teams').prop('disabled', false).removeProp('disabled');
      $('.prime-matches-section .prime-filter-item .format.include-all.include-all-tournaments')
        .prop('disabled', false).removeProp('disabled').next().removeClass('-is-disabled');

      if (!$('.prime-matches-section .prime-filter-item .format.include-all.include-all-tournaments').prop('checked')) {
        $('.form-control.prime-tournaments').prop('disabled', false).removeProp('disabled');
      }
    }
  });
}

function initMatchesImageGenerator() {
  $('.prime-matches-section .prime-matches-filter').click(function() {
    const me            = $(this);
    const oTheContainer = $('.prime-matches-container');

    const hasFrom = $('#datepicker_from').val();
    const hasTo   = $('#datepicker_to').val();

    if (!hasFrom) {
      alert('Du må velge en fra dato.' + window.oTheParams['date_to']);
      return;
    }

    // Parse dates if not already set
    if (!window.oTheParams['date_from']) {
      const from = hasFrom.split('.');
      const f    = new Date(from[2], from[1] - 1, from[0]);
      $('#datepicker_to').datepicker('option', 'minDate', f);
      window.oTheParams['date_from'] = Math.floor(f.getTime() / 1000);
    }

    if (!window.oTheParams['date_to']) {
      const to = hasTo.split('.');
      const t  = new Date(to[2], to[1] - 1, to[0]);
      $('#datepicker_from').datepicker('option', 'maxDate', t);
      window.oTheParams['date_to'] = Math.floor(t.getTime() / 1000) + 86400;
    }

    me.prop('disabled', 'disabled');
    $(oTheContainer).empty().addClass('-is-loading').append(window.sTheLoader);

    let sTheQueryString = 'matches/?usenif&size=1000'
      + '&from=' + window.oTheParams['date_from']
      + '&to='   + window.oTheParams['date_to'];

    let sTheQueryType = 'matches-all';
    let iTheQueryID   = 0;

    // Local-testing workaround: points at this site's own services/prime/
    // port instead of admin.topphandball.no/apps/prime/ on a .local domain
    // — see isLocalEnv() in prime-core.js.
    let sTheURL = (isLocalEnv()
        ? window.location.protocol + '//' + window.location.host + '/services/prime/matches-image.php'
        : window.location.protocol + '//admin.topphandball.no/apps/prime/matches-image.php')
      + '?generate=true'
      + '&from=' + window.oTheParams['date_from']
      + '&to='   + (window.oTheParams['date_to']);

    if ($('.prime-matches-section').attr('data-team-id') && !$('input#include-teams').is(':checked')) {
      sTheQueryString += '&team_id=' + $('.prime-matches-section').attr('data-team-id');
      sTheQueryType    = 'matches-team';
      sTheURL         += '&team_id=' + $('.prime-matches-section').attr('data-team-id');
    }

    if ($('.prime-matches-section').attr('data-tournament-id') && !$('input#include-tournaments').is(':checked') && !$('input#include-teams').is(':checked')) {
      sTheQueryString += '&tournament_id=' + $('.prime-matches-section').attr('data-tournament-id');
      if (!$('.prime-matches-section').attr('data-team-id')) sTheQueryType = 'matches-tournament';
      sTheURL += '&tournament_id=' + $('.prime-matches-section').attr('data-tournament-id');
    }

    if ($('input#include-teams').is(':checked')) {
      sTheQueryString += '&team_ids=' + $('.prime-matches-section').attr('data-extra-teams');
      sTheQueryType    = 'matches-team';
    }

    sTheQueryType        += '#' + $('.prime-filter-group').find('.format:checked').val();
    sTheURL              += '&format=' + $('.prime-filter-group').find('.format:checked').val();
    window.generatedImageURL = sTheURL;
    iTheQueryID           = $('.prime-matches-section').attr('data-team-id');

    window.Ajax.prime_v2(
      {
        template         : 'listing/matches/image.php',
        id               : iTheQueryID,
        queryString      : sTheQueryString,
        queryType        : sTheQueryType,
        container        : '.prime-matches-container',
        siteType         : $('.prime-matches-section').attr('data-site-type'),
        generatedImageURL: sTheURL,
      },
      function(data) {
        $(oTheContainer).html(data.markup).removeClass('-is-loading');
        me.prop('disabled', false).removeProp('disabled');
        postProcessPrimeData($(data.param.container));
      },
      function(data) { window.showError(data); }
    );
  });
}

export function initMatchesImage() {
  initMatchesImageSelectors();
  initMatchesImageGenerator();
}



// WEBPACK FOOTER //
// ./scripts/routes/common/prime-matches-image.js